import { isEmpty } from '@/lib/helpers';
import { isCustomerAuthenticatedSync } from '@/lib/login_utils';
import { authState } from '@/store/getters/auth';

export default class FlowRouterModal {
  public static getInstance(): FlowRouterModal {
    if (
      !FlowRouterModal.instance ||
      !isCustomerAuthenticatedSync(authState())
    ) {
      FlowRouterModal.instance = new FlowRouterModal();
    }
    return FlowRouterModal.instance;
  }

  private static instance: FlowRouterModal | null;

  public constructor() {
    this._status = '';
    this._type = '';
  }

  private _status: string;
  private _type: string;

  public get status(): string {
    return this._status;
  }

  public get type(): string {
    return this._type;
  }

  public set status(status: string) {
    this._status = status;
  }

  public set type(type: string) {
    this._type = type;
  }

  public setFlowRouterModal(incomingFlowRouterModal: FlowRouterModal) {
    this._status = incomingFlowRouterModal.status || '';
    this._type = incomingFlowRouterModal.type || '';
  }

  public clearInstance() {
    FlowRouterModal.instance = null;
  }
}
